// Standalone-SPA entry. Mounts the StandaloneShell at #app and reads
// query params for the orchestrator:
//   ?return=<same-origin path>   → where to navigate after success
//   ?email=<prefill>             → optional initial email
//   ?domain=<domainname>         → optional: preselect this admin domain
//   ?account=<accountname>       → optional: with ?domain=, preselect this
//                                  exact admin domain-account (account##domain)
//   ?connection=<connectionId>   → optional: preselect this client connection
//   ?locale=de|en                → optional UI locale override
//
// `domain` / `connection` are deep-link hints (e.g. from a notification
// email): after the discovery login the matching admin domain-account or
// client connection is auto-selected so the recipient skips the pickers.
//
// All host apps (ticketing, skleber, dispotix, chat-ui, JSP) point at
// /tt/login-ui/?return=<their current URL> on any 401/403. There is no
// library or widget export anymore — this is the only login surface.

import { createApp } from 'vue'
import StandaloneShell from './StandaloneShell.vue'

// Same-origin guard against open-redirect via ?return=.
// External or malformed URLs are silently replaced with the engine
// root so a tampered link can't ride a successful login off-site.
function safeReturn(raw) {
  if (!raw) return '/tt/'
  try {
    const u = new URL(raw, window.location.origin)
    if (u.origin !== window.location.origin) return '/tt/'
    return u.pathname + u.search + u.hash
  } catch (e) {
    return '/tt/'
  }
}

const params = new URLSearchParams(window.location.search)
const returnUrl = safeReturn(params.get('return'))
const initialEmail = params.get('email') || ''
const lockEmail = params.get('lockEmail') === '1' || params.get('lockEmail') === 'true'
const initialDomain = params.get('domain') || ''
const initialAccount = params.get('account') || ''
const initialConnection = params.get('connection') || ''
const locale = params.get('locale') || ''

createApp(StandaloneShell, {
  returnUrl,
  initialEmail,
  lockEmail,
  initialDomain,
  initialAccount,
  initialConnection,
  locale
}).mount('#app')
